export default {"src":"/_next/static/media/facebook.921e218d.svg","height":17,"width":9,"blurWidth":0,"blurHeight":0};